import { initialPeadValues } from "@/components/widgets/Pead/consts";
import type { QtrSelectItem } from "@/components/widgets/Pead/types";

export function sortQtrItems(
	items: QtrSelectItem[],
	state: { qtr?: string } | undefined,
) {
	const stateQtr = state?.qtr || initialPeadValues.qtr;

	const sortedItems = [...items].sort((a, b) => {
		if (a.value === stateQtr) return -1; // Move the current state item to the top
		if (b.value === stateQtr) return 1; // Move the current state item to the top
		return 0; // not sorted
	});

	return sortedItems;
}
